export const stringToInt = (string: string): number => parseInt(string, 10);
